export default function toDateOnly(datestring) {

    //const options = { year: "numeric", month: "numeric", day: "numeric"}
    //return new Date(datestring).toLocaleDateString(undefined, options)
    
    let date = new Date(datestring);
/* Date format you have */

// let sDD = "0" + date.getDate();
// sDD = sDD.substring(sDD.length-2);

// let sMM = "0" + (date.getMonth()+1);
// sMM = sMM.substring(sMM.length-2);


let dateYMD = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
//let dateYMD = `${sDD}/${sMM}/${date.getFullYear()}`;
/* Date converted to MM-DD-YYYY format */
return dateYMD

}

